'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _style = require('../style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _menu = require('../menu.c');

var _menu2 = _interopRequireDefault(_menu);

var _documentOffset = require('document-offset');

var _documentOffset2 = _interopRequireDefault(_documentOffset);

var _variables = require('../variables');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuItem = function (_View) {
    _inherits(MenuItem, _View);

    function MenuItem() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MenuItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            active: false,
            position: _variables.X_POSITION_RIGHT + '-' + _variables.Y_POSITION_TOP
        }, _this._rootRef = function (el) {
            return _this.root = el;
        }, _this._subMenuRef = function (el) {
            return _this.subMenu = el;
        }, _this._handleMouseEnter = function () {
            _this.setState({ active: true }).then(function () {
                _this.setState({ position: _this.getPosition() });
            });
        }, _this._handleMouseLeave = function () {
            _this.setState({ active: false });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MenuItem, [{
        key: 'render',
        value: function render() {
            var classList = this.compileStyle(_style2.default),
                _state = this.state,
                active = _state.active,
                position = _state.position,
                children = _react2.default.Children.toArray(this.props.children),
                subMenu = void 0,
                items = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {

                for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.type === _menu2.default) {
                        subMenu = item;
                        // take it from props on Menu components
                        // because of this props are not logical part of MenuItem component
                        this.rightTop = item.props.rightTop;
                        this.rightBottom = item.props.rightBottom;
                        this.leftTop = item.props.leftTop;
                        this.leftBottom = item.props.leftBottom;
                    } else {
                        items.push(item);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return _react2.default.createElement(
                'div',
                {
                    className: classList.itemWrapper,
                    onMouseEnter: subMenu ? this._handleMouseEnter : null,
                    onMouseLeave: subMenu ? this._handleMouseLeave : null,
                    ref: this._rootRef
                },
                active ? _react2.default.createElement(
                    'div',
                    { className: classList[position], ref: this._subMenuRef },
                    subMenu
                ) : null,
                _react2.default.createElement(
                    'div',
                    _extends({}, this.props, { theme: null, className: classList.item }),
                    items
                )
            );
        }
    }, {
        key: 'getPosition',
        value: function getPosition() {
            var elWidth = this.root.offsetWidth,
                elHeight = this.root.offsetHeight,
                offset = void 0,
                subMenuWdith = void 0,
                subMenuHeight = void 0,
                docH = window.document.documentElement.offsetHeight,
                docW = window.document.documentElement.offsetWidth,
                bottomAvailable = true,
                topAvailable = true,
                leftAvailable = true,
                rightAvailable = true,
                xPosition = _variables.X_POSITION_RIGHT,
                yPosition = _variables.Y_POSITION_TOP;

            offset = (0, _documentOffset2.default)(this.root);
            subMenuWdith = this.subMenu.offsetWidth;
            subMenuHeight = this.subMenu.offsetHeight;

            if (offset) {
                // нет места снизу
                if (offset.top + subMenuHeight > docH) {
                    bottomAvailable = false;
                }

                // нет места сверху
                if (offset.top + elHeight - subMenuHeight <= 0) {
                    topAvailable = false;
                }

                // нет места справа
                if (offset.left + elWidth + subMenuWdith > docW) {
                    rightAvailable = false;
                }

                // нет места слева
                if (offset.left - (elWidth + subMenuWdith) <= 0) {
                    leftAvailable = false;
                }
            }

            if (this.rightTop) {
                xPosition = rightAvailable ? _variables.X_POSITION_RIGHT : leftAvailable ? _variables.X_POSITION_LEFT : _variables.X_POSITION_RIGHT;
                yPosition = bottomAvailable ? _variables.Y_POSITION_TOP : topAvailable ? _variables.Y_POSITION_BOTTOM : _variables.Y_POSITION_TOP;
            } else if (this.rightBottom) {
                xPosition = rightAvailable ? _variables.X_POSITION_RIGHT : leftAvailable ? _variables.X_POSITION_LEFT : _variables.X_POSITION_RIGHT;
                yPosition = topAvailable ? _variables.Y_POSITION_BOTTOM : _variables.Y_POSITION_TOP;
            } else if (this.leftTop) {
                xPosition = leftAvailable ? _variables.X_POSITION_LEFT : _variables.X_POSITION_RIGHT;
                yPosition = bottomAvailable ? _variables.Y_POSITION_TOP : topAvailable ? _variables.Y_POSITION_BOTTOM : _variables.Y_POSITION_TOP;
            } else if (this.leftBottom) {
                xPosition = leftAvailable ? _variables.X_POSITION_LEFT : _variables.X_POSITION_RIGHT;
                yPosition = topAvailable ? _variables.Y_POSITION_BOTTOM : _variables.Y_POSITION_TOP;
            }

            return xPosition + '-' + yPosition;
        }
    }]);

    return MenuItem;
}(_Component2.default);

MenuItem.displayName = 'MenuItem';
exports.default = MenuItem;